import { render, staticRenderFns } from "./licen-dialog.vue?vue&type=template&id=2cf83174&scoped=true&"
import script from "./licen-dialog.vue?vue&type=script&lang=js&"
export * from "./licen-dialog.vue?vue&type=script&lang=js&"
import style0 from "./licen-dialog.vue?vue&type=style&index=0&id=2cf83174&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf83174",
  null
  
)

export default component.exports